import { RejectedManagerPage } from "./RejectedManagerPage";

const RejectedManager = () => {
	return <RejectedManagerPage />;
};
export default RejectedManager;
